import { map, mapValues, mapKeys, isPlainObject, isArray } from 'lodash';
import formatDate from 'date-fns/format';
var getUtcDate = function (dateString) {
    var date = new Date(dateString);
    return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
};
export var getUtcTimestamp = function (date) {
    if (date === void 0) { date = Date.now(); }
    return formatDate(getUtcDate(date), 'YYYY-MM-DD HH:mm:ss');
};
export var dive = function (mapper) { return function (source, iteratee) {
    if (typeof source !== 'object') {
        return source;
    }
    return mapper(mapValues(source, function (v) {
        if (isPlainObject(v)) {
            return dive(mapper)(v, iteratee);
        }
        else if (isArray(v)) {
            return map(v, function (item) { return dive(mapper)(item, iteratee); });
        }
        return v;
    }), iteratee);
}; };
export var deepMapKeys = function (obj, fn) { return dive(mapKeys)(obj, fn); };
//# sourceMappingURL=utils.js.map